import * as styled from "./MessageBubble.styled"

function MessageBubble({isOwn, message}){
  return (
    <styled.Wrapper>
      <styled.Bubble isOwn={isOwn}>
        {message.text}
        <styled.Time>{message.time}</styled.Time>
      </styled.Bubble>
    </styled.Wrapper>
  )
};

export default MessageBubble;
